import http from '@/http';

// state
export const state = {
    measure: {},
    measures: [],
};

// mutations
export const mutations = {
    SET_MEASURES(state, measures) {
        state.measures = measures;
    },
    SELECT_MEASURE(state, measure) {
        state.measure = measure;
    },
};

// actions
export const actions = {
    fetch({ rootState, commit }) {
        http.get('ItemBank/GetItemBank?customerID=something', { baseURL: rootState.auth.url })
            .then(measures => {
                commit('SET_MEASURES', measures);
            });
    },
};

// getters
export const getters = {};
